import { render, staticRenderFns } from "./getcode.vue?vue&type=template&id=8400dd92&scoped=true&"
import script from "./getcode.vue?vue&type=script&lang=js&"
export * from "./getcode.vue?vue&type=script&lang=js&"
import style0 from "./getcode.vue?vue&type=style&index=0&id=8400dd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8400dd92",
  null
  
)

export default component.exports